module.exports = __webpack_public_path__ + "static/media/Logo.3c6892b5.svg";